import { render } from "./update-product.vue?vue&type=template&id=13e0d91c&scoped=true"
import script from "./update-product.vue?vue&type=script&lang=js"
export * from "./update-product.vue?vue&type=script&lang=js"

import "./update-product.vue?vue&type=style&index=0&id=13e0d91c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Haniel\\Desktop\\PROJECTS\\TANOU-ACADEMY\\e-commerce-webadmin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_2cebe3dcb9a4454fa15f9df2c44405de\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e0d91c"]])

export default __exports__